/**
 * ÖDEME DEKONTU — PDF'i açma / indirme.
 *
 * Dekont birden fazla ekrandan isteniyor (Hareketler listesi, cari hesap
 * ekstresi, kasa hesabı ekstresi ve hareket kaydedildikten sonra çıkan pencere);
 * ortak yer burası, ekranlar ayrışmasın.
 *
 * PDF, JWT'li istemciyle BLOB olarak alınır: adresi doğrudan yeni sekmede açmak
 * kimlik doğrulama başlığını taşımaz ve uç 401 döner.
 */
import api from '@/lib/api';
import { toast } from 'sonner';

export const dekontDosyaAdi = (id) => `Dekont-${String(id).slice(0, 8).toUpperCase()}.pdf`;

export async function dekontuAc(id, indir = false) {
  try {
    const r = await api.get(`/treasury/transactions/${id}/dekont`,
      { params: { indir }, responseType: 'blob' });
    const url = URL.createObjectURL(r.data);
    if (indir) {
      const a = document.createElement('a');
      a.href = url;
      a.download = dekontDosyaAdi(id);
      document.body.appendChild(a);
      a.click();
      a.remove();
    } else if (!window.open(url, '_blank')) {
      toast.info('Açılır pencere engellendi — dekontu indirebilirsiniz');
    }
    // Sekme PDF'i okuyana kadar dursun; sonra bellekten düşsün
    setTimeout(() => URL.revokeObjectURL(url), 60000);
    return true;
  } catch (err) {
    // Hata gövdesi de blob gelir (responseType), okunabilir mesaj için metne çevrilir
    let mesaj = 'Dekont oluşturulamadı';
    try { mesaj = JSON.parse(await err.response.data.text()).detail || mesaj; } catch { /* yoksay */ }
    toast.error(mesaj, { duration: 7000 });
    return false;
  }
}
